module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJBQEJ9LkK/AAAAC3RSTlMAYL//ACDP7xCfMN+6hX4AAACfSURBVHgBYxhZQMjYWNEFDTCg8cOMgSAVvyLXYpAi8xC8ityMwSAFryJhiCJDvIqUIYqM8CoyhgI6K6LU4YggoDQwEdFCfgQjAL6kggAeLS6YijDBCFQUWWyME5hPhSjyAqrBo2oJWFG4MV5QClY0Gb8iS7CiYvyKzMGKjAkAYhURto5YhxMOAiIDk3C0kJ8KRhWN1i0kKBqtW0ZWbgEAYbhSl9GUaYQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2797.png
// module id = 1411
// module chunks = 0